import React from 'react';
import { Table } from 'reactstrap';
import i18n from "../../../i18next";
import MaterialIcon from "material-icons-react";

import CashSVG from '../../common/svgs/CashSVG';
import CardsSVG from '../../common/svgs/CardsSVG';
import LoyaltyIconSvg from '../../common/svgs/LoyaltyIconSVG';
import DeliverySVG from "../../common/svgs/DeliverySVG"
import PickUpSVG from "../../common/svgs/PickUpSVG";
import CurbsideSVG from "../../common/svgs/CurbsideSVG";
import InStoreSvg from "../../common/svgs/InStoreSVG";
import WebSVG from '../../common/svgs/WebSVG';
import MobileIconSVG from '../../common/svgs/MobileIconSVG';
import AppAndroidSVG from '../../common/svgs/AppAndroidSVG';
import AppAppleSVG from '../../common/svgs/AppAppleSVG';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import GiftCardSVG from '../../common/svgs/GiftCardSvg';

const TableSection = props => {

    const tableDetails = {
        orderTypes: {
            headers: [i18n.t('screens:customerInsightScreen.type'), i18n.t('screens:customerInsightScreen.count'), i18n.t('screens:customerInsightScreen.totalAmount')],
    
        },
        paymentTypes: {
            headers: [i18n.t('screens:customerInsightScreen.type'), i18n.t('screens:customerInsightScreen.count'), i18n.t('screens:customerInsightScreen.totalAmount')],
    
        },
        sourceTypes: {
            headers: [i18n.t('screens:customerInsightScreen.type'), i18n.t('screens:customerInsightScreen.count'), i18n.t('screens:customerInsightScreen.totalAmount')],
    
        },
        products: {
            headers: [i18n.t('screens:customerInsightScreen.items'), i18n.t('screens:customerInsightScreen.quantity'), i18n.t('screens:customerInsightScreen.price')],
    
        },
        promotions: {
            headers: [i18n.t('screens:customerInsightScreen.promotion'), i18n.t('screens:customerInsightScreen.dateRedeemed'), i18n.t('screens:customerInsightScreen.totalSpent')],
    
        },
        restaurantPromotions: {
            headers: [i18n.t('screens:restaurantInsightScreen.restaurantPromotions'), i18n.t('screens:restaurantInsightScreen.discountType'), i18n.t('screens:restaurantInsightScreen.discount')],
        },
        promoCodes: {
            headers: [i18n.t('screens:restaurantInsightScreen.promoCode'), i18n.t('screens:customerInsightScreen.count'), i18n.t('screens:restaurantInsightScreen.discount'), i18n.t('screens:customerInsightScreen.promotion')],
        },
        restaurantPaymentTypes: {
            headers: [i18n.t('screens:customerInsightScreen.type'), i18n.t('screens:customerInsightScreen.count'), i18n.t('screens:customerInsightScreen.totalAmount')],
        },
        restaurantSourceTypes: {
            headers: [i18n.t('screens:customerInsightScreen.type'), i18n.t('screens:customerInsightScreen.count'), i18n.t('screens:customerInsightScreen.totalAmount')],
        },
        restaurantOrderTypes: {
            headers: [i18n.t('screens:customerInsightScreen.type'), i18n.t('screens:customerInsightScreen.count'), i18n.t('screens:customerInsightScreen.totalAmount')],
        },
        restaurantProducts: {
            headers: [i18n.t('screens:customerInsightScreen.items'), i18n.t('screens:customerInsightScreen.quantity'), i18n.t('screens:customerInsightScreen.price')],
        }
    }

    const renderHeaders = () => {
        
        const { tableHeaders, textCenter, textRight } = styles;
        const headers = tableDetails[props.type]['headers'];

        return (
            <tr>
                <th style={tableHeaders}>{headers[0]}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{headers[1]}</th>
                {headers.length === 3 ? <th style={{ ...tableHeaders, ...textRight }}>{headers[2]}</th> 
                :  <th style={{ ...tableHeaders, ...textCenter }}>{headers[2]}</th>}
                {headers.length === 4 && <th style={{ ...tableHeaders, ...textRight }}>{headers[3]}</th>}
            </tr>
        );
    }

    const renderTableDetailRows = (type, content) => {
        if(type === 'restaurantPaymentTypes') {
            return content.paymentTypeSummary.map((row)  => {
                return renderTableRow(type, row);
            })
        } else if (type === 'restaurantSourceTypes') {
            return content.sourceTypeSummary.map((row)  => {
                return renderTableRow(type, row);
            })
        } else if (type === 'restaurantOrderTypes'){
            return content.orderTypeSummary.map((row)  => {
                return renderTableRow(type, row);
            })
        } else {
            return content.map((row)  => {
                return renderTableRow(type, row);
            })
        }  
    }

    const mapQuantityColumn = (type, rowDetails) => {
        const { tableDetail, firstRow, textCenter, textRight, verticleAlignCenter } = styles; 

        if(type === "promotions") {
            return <td style={{ ...tableDetail, ...textCenter }}>{rowDetails.usedDate.slice(0, -3)}</td>
        } else if (type === "restaurantProducts") {
            return <td style={{ ...tableDetail, ...textCenter }}>{rowDetails.quantity}</td>
        } else if (type === "restaurantPromotions") {
            return <td style={{ ...tableDetail, ...textCenter }}>{typeMapTemplate(rowDetails.discountTypeId, props.type)}</td>
        } else {
            return <td style={{ ...tableDetail, ...textCenter }}>{rowDetails.count}</td>
        }
    }

    const renderTableRow = (type, rowDetails) => {
        const { tableDetail, firstRow, textCenter, textRight, verticleAlignCenter } = styles; 
        const rowType = formatRowTypeText(type, (type === 'restaurantPaymentTypes' || type === 'restaurantSourceTypes' || type === 'restaurantOrderTypes') ? typeMapTemplate(rowDetails.typeIndex, type) : type === 'promoCodes' ? rowDetails.promoCode : rowDetails.name);
        const rowIcon = formatRowTypeIcon(type, (type === 'restaurantPaymentTypes' || type === 'restaurantSourceTypes' || type === 'restaurantOrderTypes') ? rowDetails.typeIndex : rowDetails.typeId);
        const total = formatTotal(type, rowDetails, props.currency);

        return (
            <tr>
                {rowIcon ?
                    <td style={{ ...tableDetail, ...firstRow, ...verticleAlignCenter }}>{rowIcon}&nbsp;&nbsp;{rowType}</td> :
                    <td style={{ ...tableDetail, ...firstRow }}>{rowType}</td> 
                }
                {
                    // type === "promotions" ? 
                    // <td style={{ ...tableDetail, ...textCenter }}>{rowDetails.usedDate.slice(0, -3)}</td> : 
                    // <td style={{ ...tableDetail, ...textCenter }}>{rowDetails.count}</td>
                    mapQuantityColumn(type, rowDetails)
                }
                {type === "promoCodes" ? <td style={{ ...tableDetail, ...textCenter }}>{total}</td> : <td style={{ ...tableDetail, ...textRight }}>{total}</td>}
                {type === "promoCodes" && <td style={{ ...tableDetail, ...textRight }}>{rowDetails.promotionName}</td>}
            </tr>
        );
    }

    return (
        <Table style={{ marginBottom: '0' }}>
            <thead>
                {renderHeaders()}
            </thead>
            <tbody>
                {renderTableDetailRows(props.type, props.content)}
            </tbody>
        </Table>
    );
}

export default TableSection;

const formatRowTypeText = (type, name) => {
    switch (type) {
        case 'orderTypes':
        case 'restaurantOrderTypes': {
            return formatType(name)
        }
        case 'paymentTypes': 
        case 'restaurantPaymentTypes':
        {
            return formatType(name)
        }
        case 'sourceTypes':
        case 'restaurantSourceTypes': {
            return formatType(name)
        }
        case 'products':
        case 'restaurantProducts':
        case 'restaurantPromotions':
        case 'promoCodes':
        case 'promotions': return name;
        default: return null;
    }
}

const formatRowTypeIcon = (type, typeId) => {
    switch (type) {
        case 'orderTypes':
        case 'restaurantOrderTypes': {
            return renderOrderSVGIcon(typeId);
        }
        case 'paymentTypes':
        case 'restaurantPaymentTypes': {
            return renderPaymentSVGIcon(typeId);
        }
        case 'sourceTypes':
        case 'restaurantSourceTypes': {
            return rendersourceTypeIcon(typeId);
        }
        default: return null;
    }
}

const renderPaymentSVGIcon = typeId => {
    switch (typeId) {
        case 1: return <CardsSVG width={15} height={15} fill={'#0288D1'} />;
        case 2: return <CashSVG width={15} height={15} fill={'#0288D1'} />
        case 3: return <LoyaltyIconSvg width={15} height={15} fill={'#0288D1'} />
        case 4: return <GiftCardSVG width={20} height={20} fill={'#0288D1'} />
        default: return null
    }
}

const renderOrderSVGIcon = typeId => {
    switch (typeId) {
        case 1: return <DeliverySVG width={15} height={15} fill={'#0288D1'} />;
        case 2: return <PickUpSVG width={15} height={15} fill={'#0288D1'} />
        case 4: return <CurbsideSVG width={15} height={15} fill={'#0288D1'} />
        case 5: return <InStoreSvg width={15} height={15} fill={'#0288D1'} />
        default: return null
    }
}

const rendersourceTypeIcon = typeId => {
    switch (typeId) {
        case 1: return <WebSVG width={13} height={13} fill={'#0288D1'} />
        case 2: return <MobileIconSVG width={15} height={15} fill={'#0288D1'} />
        case 3: return <MobileIconSVG width={15} height={15} fill={'#0288D1'} />
        case 4: return <AppAppleSVG width={15} height={15} fill={'#0288D1'} />
        case 5: return <AppAndroidSVG width={15} height={15} fill={'#0288D1'} />
        default: return null
    }
}

const formatType = name => {
    switch (name) {
        case 'Delivery': return i18n.t(`screens:customerInsightScreen.Delivery`);
        case 'PickUp': return i18n.t(`screens:customerInsightScreen.Collection`);
        case 'Curbside': return i18n.t(`screens:customerInsightScreen.Curbside`);
        case 'DinePay': return i18n.t(`screens:restaurantsMainContainer.instore`);
        case 'Cash': return i18n.t(`screens:customerInsightScreen.cash`);
        case 'CreditCard': return i18n.t(`screens:customerInsightScreen.creditCard`);
        case 'Loyalty': return i18n.t(`screens:customerInsightScreen.loyalty`);
        case 'Gift card': return i18n.t(`screens:restaurantInsightScreen.giftCard`);
        case 'Giftcard': return i18n.t(`screens:restaurantInsightScreen.giftCard`);
        case 'WEB': 
        case 'Web': return 'Web';
        case 'WEB_ANDROID':
        case 'Web Android': return 'Web Android';
        case 'WEB_IOS': 
        case 'Web IOS': return 'Web IOS';
        case 'APP_ANDROID': 
        case 'App Android': return 'App Android';
        case 'APP_IOS': 
        case 'App IOS': return 'App IOS';
        default: return null;
    }
}

const formatTotal = (type, rowDetails, currency) => {
    switch (type) {
        case 'orderTypes':
        case 'paymentTypes':
        case 'sourceTypes':
        case 'restaurantPaymentTypes':
        case 'restaurantSourceTypes':
        case 'restaurantOrderTypes': {
            return getPriceWithCurrencySymbol(rowDetails.total, currency);
        }
        case 'products':
        case 'restaurantProducts':
        case 'promotions': {
            return getPriceWithCurrencySymbol(rowDetails.totalSpent, currency);
        }
        case 'restaurantPromotions': {
            return getPriceWithCurrencySymbol(rowDetails.discount, currency);
        }
        case 'promoCodes': {
            return getPriceWithCurrencySymbol(rowDetails.totalDiscount, currency);
        }
        default: return null;
    }
}

    const typeMapTemplate = (elementType, type) => {
        if(type === 'restaurantPaymentTypes') {
            switch (elementType) {
                case 1: return "CreditCard";
                case 2: return "Cash";
                case 3: return "Loyalty";
                case 4: return "Giftcard";
                default: return null;
            } 
        } else if (type === 'restaurantSourceTypes') {
            switch (elementType) {
                case 1: return "Web";
                case 2: return "Web IOS";
                case 3: return "Web Android";
                case 4: return "App IOS";
                case 5: return "App Android";
                default: return null;
            }
        } else if (type === 'restaurantOrderTypes') {
            switch(elementType) {
                case 1: return "Delivery";
                case 2: return "PickUp";
                case 4: return "Curbside";
                case 5: return "DinePay";
                default: return null;
            }
        } else if (type === 'restaurantPromotions') {
            switch(elementType) {
                case 0: return "External Discount";
                case 1: return "Price Discount";
                case 2: return "Free product";
                case 3: return "Combo deal";
                case 4: return "Loyalty";
                default: return null;
            }
        }
    }

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '12px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    verticleAlignCenter: {
        display: 'flex',
        alignItems: 'center'
    }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/TableSection.js